import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import moment from 'moment-timezone'
import withHandlers from 'recompose/withHandlers'
import branch from 'recompose/branch'
import renderNothing from 'recompose/renderNothing'
import withProps from 'recompose/withProps'
import withState from 'recompose/withState'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'

import ScheduleModal from './component'

const mapStateToProps = state => ({
  draftScheduledTimestamp: PlaybookSelectors.dueAt(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideScheduleModal: PlaybookActions.hideScheduleModal,
      setDraftSchedule: PlaybookActions.setDraftSchedule,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('selectedDateTime', 'setDateTime', props =>
    moment(props.draftScheduledTimestamp).tz(moment.tz.guess())
  ),
  withProps(props => ({
    selectedDateTimeFormatted: (
      <span>
        {props.selectedDateTime.format('ddd MMM D, YYYY')} at{' '}
        <div>{props.selectedDateTime.format('h:mmA zz')}</div>
      </span>
    ),
  })),
  withHandlers({
    onCloseClick: props => () => {
      props.actions.hideScheduleModal()
    },
    handleSetDateTime: props => m => {
      props.setDateTime(m.tz(moment.tz.guess()))
    },
    handleSaveDateTime: props => () => {
      props.actions.setDraftSchedule(props.selectedDateTime)
      props.actions.hideScheduleModal()
    },
  }),
  branch(props => !props.selectedDateTime, renderNothing)
)(ScheduleModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ScheduleModal/index.js